// eslint-disable-next-line import/no-extraneous-dependencies
import html2canvas from 'html2canvas';

export const CHART_COLORS = [
  '#0D47A1',
  '#1565C0',
  '#1976D2',
  '#1E88E5',
  '#2196F3',
  '#42A5F5',
  '#64B5F6',
  '#90CAF9',
  '#BBDEFB',
  '#E3F2FD',
];

/**
 * Capture chart element as image blob
 * @param {React.RefObject} chartRef - Reference to the chart DOM element
 * @returns {Promise<Blob|null>} Image blob or null if failed
 */
export const captureChartAsImage = async (chartRef) => {
  if (!chartRef.current) return null;

  try {
    const canvas = await html2canvas(chartRef.current, {
      backgroundColor: '#ffffff',
      scale: 2,
      useCORS: true,
      allowTaint: false,
    });

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, 'image/png');
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error capturing chart:', error);
    return null;
  }
};

/**
 * Download chart as PNG image
 * @param {React.RefObject} chartRef - Reference to the chart DOM element
 * @param {string} filename - Filename for the downloaded image
 */
export const downloadChartAsImage = async (
  chartRef,
  filename = 'chart.png',
) => {
  const imageBlob = await captureChartAsImage(chartRef);

  if (!imageBlob) {
    return;
  }

  const imageUrl = URL.createObjectURL(imageBlob);
  const imageLink = document.createElement('a');
  imageLink.href = imageUrl;
  imageLink.download = filename;
  imageLink.click();

  URL.revokeObjectURL(imageUrl);
};
